export default __webpack_public_path__ + "static/media/mobileScreen2.396638e9.png";